import _ from 'lodash';
import { set } from '@jgile/laravel-vue/resources/js/util';
import Errors from './Errors';

class Form {
    get errors() {
        return this._errors;
    }

    constructor(data) {
        set(this, 'busy', false);
        set(this, 'successful', false);
        set(this, '_errors', new Errors());

        _.merge(this, data);
    }

    /**
     * Start processing the form.
     */
    startProcessing() {
        this._errors.forget();
        this.busy = true;
        this.successful = false;
    }

    /**
     * Finish processing the this.
     */
    finishProcessing() {
        this.busy = false;
        this.successful = true;
    }

    /**
     * Reset the errors and other state for the form.
     */
    resetStatus() {
        this.errors.forget();
        this.busy = false;
        this.successful = false;
    }

    /**
     * Set the errors on the form.
     */
    setErrors(errors) {
        this.busy = false;
        this._errors.set(_.get(errors, 'response.data.errors', errors));
    }

    /**
     * Helper method for making POST HTTP requests.
     */
    get(uri) {
        return this.sendForm('get', uri);
    }

    /**
     * Helper method for making POST HTTP requests.
     */
    post(uri, data = null) {
        return this.sendForm('post', uri, data || this);
    }

    /**
     * Helper method for making PUT HTTP requests.
     */
    put(uri, data = null) {
        return this.sendForm('put', uri, data || this);
    }

    /**
     * Helper method for making PATCH HTTP requests.
     */
    patch(uri, data = null) {
        return this.sendForm('patch', uri, data || this);
    }

    /**
     * Helper method for making DELETE HTTP requests.
     */
    delete(uri, data = null) {
        return this.sendForm('delete', uri, data || this);
    }

    /**
     * Send the form to the back-end server.
     *
     * This function will clear old errors, update "busy" status, etc.
     */
    sendForm(method, uri, data = null) {
        return this.request({
            url: uri,
            method: method,
            data: data || this,
        });
    }

    /**
     * Request.
     *
     * @param config
     * @returns {Promise}
     */
    request(config) {
        const self = this;

        return new Promise((resolve, reject) => {
            self.startProcessing();

            return axios
                .request(config)
                .then((response) => {
                    self.finishProcessing();

                    resolve(response.data);
                })
                .catch((errors) => {
                    self.setErrors(errors);
                    reject(errors.response.data);
                });
        });
    }
}

export default Form;
